import axios from 'axios';
import React, { Component } from 'react';
import moment from 'moment';
import papa from 'papaparse';
import { Button } from '@material-ui/core';
import classes from '../Modals/./Modals.css';
import CSV from './CSV';
import QIF from './QIF';
import { ROOT_URL } from '../../Actions/types';
import { write } from './qifHelper';

class UploadTransactions extends Component {

    state = { showError: false, confirmType: '', columns: [], file: '', data: '' };

    selectOptions = [
        { value: 'ignore', label:'Ignore', isAssignedTo: null }, 
        { value: 'date', label:'Date', isAssignedTo: null }, 
        { value: 'ref', label:'Ref no.', isAssignedTo: null }, 
        // { value: 'type', label:'Type', isAssignedTo: null }, 
        { value: 'description', label:'Description', isAssignedTo: null }, 
        { value: 'moneyOut', label:'Money Out', isAssignedTo: null },
        { value: 'moneyIn', label:'Money In', isAssignedTo: null },
        { value: 'amount', label:'Amount', isAssignedTo: null },
        { value: 'revAmount', label:'Reversed Amount', isAssignedTo: null }
    ];

    handleUploadFile = (event) => {
        const file = event.target.files[0];
        this.setState({ file });
        if (file.name.toLocaleLowerCase().includes('.qif')) {
            const data = new FormData();
            data.append('file', file);
            axios.post(`${ROOT_URL}/books/upload`, data,
            { headers: { authorizationtoken: localStorage.getItem("token"), cognitotoken: localStorage.getItem("cognitotoken"), authtype: localStorage.getItem("authtype") } })
            .then((response) => {
                this.setState({ confirmType: 'qif', data: response.data });
            })
            .catch((err) => {
                this.props.showError('There was a problem uploading your file');
            });
        } else if (file.name.toLocaleLowerCase().includes('.csv')) {
            this.processCSV(file);
            this.setState({ confirmType: 'csv' });
        } else if (file.name.toLocaleLowerCase().includes('.txt')) {
            this.processTXT(file, ',');
            this.setState({ confirmType: 'txt' });
        } else {
            this.props.showError('You may only upload files in qif/csv/txt format');
        }
    }

    processCSV = (file, textQualifier= '"') => {
        papa.parse(file, {
            complete: (result, file) => {
                const maxLength = this.getMaxLength(result.data);
                const data = this.fillBlankColumns(result.data, maxLength);
                this.setState({ columns: data })
            },
            skipEmptyLines: 'greedy',
            quoteChar: textQualifier
        });
    }

    processTXT = (file, separator, textQualifier = '"') => {
        let fileContent = "";
        const fr = new FileReader();
        fr.onload = () => {
            fileContent = fr.result.trim();
            const regex = new RegExp(`${separator}(?=(?:(?:[^${textQualifier}]*${textQualifier}){2})*[^${textQualifier}]*$)`);
            const replaceRegex = new RegExp(`^${textQualifier}(.*)${textQualifier}$`);
            let newArr = fileContent.split('\n').map(e => e.split(regex).map(i => {
                let element = i.trim();
                if (textQualifier) return element.replace(replaceRegex, '$1');
                return element;
            }));
            const maxLength = this.getMaxLength(newArr);
            const data = this.fillBlankColumns(newArr, maxLength);
            this.setState({ columns: newArr })
        }
        fr.readAsText(file);
        this.selectOptions.forEach((o, i, a) => a[i].isAssignedTo = null)
    }

    getMaxLength = array => { // Find the maximum number of columns so that we can create that much td elements
        return Math.max(...array.map(element => {
            if (element[element.length - 1] === "") element.pop(); // skip last column if empty (some csv file ends lines with both comma and newline)
            return element.length;
        }));
    }

    fillBlankColumns = (array, max) => { // make sure every row has all columns
        return array.map(row => {
            for (let i = 0; i < max; i++) {
                if (row[i] === undefined) row[i] = "";
            }
            return row;
        })
    }

    importQIF = () => {
        return this.props.importQIF(this.state.data);
    }

    importCSV = data => {
        return this.props.importCSV(data);
    }

    render () {
      if (this.state.confirmType === 'qif') return <QIF importQIF={this.importQIF} onClose={this.props.onClose} data={this.state.data} account={this.props.account} />;
      if (this.state.confirmType === 'csv' || this.state.confirmType === 'txt') return <CSV confirmType={this.state.confirmType} processCSV={this.processCSV} processTXT={this.processTXT} importCSV={this.importCSV} onClose={this.props.onClose} showError={this.props.showError} selectOptions={this.selectOptions} file={this.state.file} columns={this.state.columns}/>;

      return (
        <div className={classes.container}>
            <h3>Upload Transactions</h3>
            <div className={classes.infoBox}>
                <p className={classes.centerText}>Upload transactions into <strong>{this.props.account.label}</strong>. </p>
                <p className={classes.smallGey}>(Supported File Types: QIF, CSV & TXT)</p>
            </div>
            <input
                accept=".qif,.csv,.txt"
                className={classes.hideInput}
                id="contained-button-file"
                type="file"
                onChange={this.handleUploadFile}
            />
            <div style={{ marginTop: 16, maxWidth: 490, paddingBottom: 20, fontSize: 13, color: '#888' }}>
                <strong style={{ color: '#444' }}>Important:</strong> Uploading transactions may create duplicates if you have previously exported and worked on them offline. <a href="https://help.reckon.com/article/xubasickql-fast-coding" target="_blank" rel="noopener noreferrer" style={{ color: '#0b6d87ff' }}>Learn more about in fast coding</a>
            </div>
            <label htmlFor="contained-button-file">
                <Button variant="contained" color="primary" component="span" className={classes.button}>Upload</Button>&nbsp;&nbsp;&nbsp;
                <Button variant="contained" className={classes.button} onClick={this.props.onClose}>Cancel</Button>
            </label>
      </div>
    );  
    }
}

export default UploadTransactions;



// WEBPACK FOOTER //
// ./src/components/UploadTransactions/UploadTransactions.js